// data interface for fetching news list
// adjust baseUrl to match your backend

const baseUrl = process.env.VUE_APP_API_BASE_URL || '';

/**
 * 获取新闻列表
 * @param {Object} params 查询参数，比如页码、条数等
 * @returns {Promise<Object>} 返回接口响应数据
 */
export function getNewsList(params = {}) {
  // 使用原生 fetch
  // 如果你已经在项目中使用 axios, 可替换为 axios.get
  const query = new URLSearchParams(params).toString();
  const url = `${baseUrl}/index/getAboutList${query ? `?${query}` : ''}`;

  return fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Network response was not ok (${response.status})`);
      }
      return response.json();
    })
    .catch(err => {
      console.error('getNewsList error:', err);
      throw err;
    });
}

export function getText(params = {}) {
  // 使用原生 fetch
  // 如果你已经在项目中使用 axios, 可替换为 axios.get
  const query = new URLSearchParams(params).toString();
  const url = `${baseUrl}/index/getText${query ? `?${query}` : ''}`;

  return fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Network response was not ok (${response.status})`);
      }
      return response.json();
    })
    .catch(err => {
      console.error('getText error:', err);
      throw err;
    });
}
